import type { Ack } from '../shared/protocol';

export function request<T>(dispatch: (ack: Ack<T>) => void, timeoutMs = 8_000): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = window.setTimeout(
      () => reject(new Error('The server did not respond. Check the connection and retry.')),
      timeoutMs
    );
    dispatch((result) => {
      window.clearTimeout(timer);
      if (result.ok) resolve(result.data);
      else reject(new Error(result.error));
    });
  });
}
